/**
 * Middleware to control access to My Account pages.
 *
 * This middleware redirects unauthenticated users attempting to access
 * My Account pages to the signup page. It excludes help/my-account routes.
 *
 * @returns {void|NavigationFailure} Redirects to signup page if user is not logged in
 * @example
 * // Automatically redirects to signup if trying to access my-account without authentication
 * export default defineNuxtRouteMiddleware((to) => { ... })
 */
export default defineNuxtRouteMiddleware(to => {
  const { loggedIn: isLogged } = useUserSession()
  const localePath = useLocalePath(to)

  if (
    !isLogged.value &&
    (to.name as string)?.includes('my-account') &&
    !(to.name as string)?.includes('help/my-account')
  ) {
    const currentPageBeforeLogin = useCookie('page-before-login', {
      domain: import.meta.dev ? 'localhost' : '.armani.com',
    })
    currentPageBeforeLogin.value = useRequestURL().href

    return navigateTo(localePath('/signup'))
  }
})
